import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import substanceDrugsInvolvementItemValidator from './validators/item';
import { SubstanceDrugsInvolvementModel } from './types';

const substanceDrugsInvolvementsValidator: ValidateJSModel<SubstanceDrugsInvolvementModel> = {
  Involved: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.Involved && attributes?.Involved.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: substanceDrugsInvolvementItemValidator,
        },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceDrugsInvolvementsValidator;
